import { render, staticRenderFns } from "./PromotionInvitationEditForm.vue?vue&type=template&id=3a39d304"
import script from "./PromotionInvitationEditForm.vue?vue&type=script&lang=js"
export * from "./PromotionInvitationEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports